// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3429":"6faf153c","4919":"6faf153c","9640":"6faf153c"}[chunkId] + ".chunk.css";
};